<template>
    <div class="focusNews">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-tabs v-model="activeName" @tab-click="handleClick" class="newHospitalMain" style="padding-top:20px">
                <el-tab-pane :label="item.name" :name="'index' + index" v-for="(item,index) in newHospital" :key="index">
                    <el-row style="width:100%">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <ul>
                                <li v-for="(list,index2) in item.articles" :key="index2" >
                                    <a @click="rowClick(list)"><i></i>{{list.title}}</a>
                                    <span>{{list.releaseTime|dateFormat}}</span>
                                </li>
                            </ul>
                        </el-col>
                        <el-col class="hidden-xs-only hidden-sm-only" :md="12" :lg="12" :xl="12">
                            <div class="newHospitalMainImg" @click="rowClick(newHospital[index].articles[0])">
                                <img :src="newHospital[index].articles.length > 0 ? newHospital[index].articles[0].picUrl : ''">
                                <p>{{ newHospital[index].articles.length > 0 ? newHospital[index].articles[0].title : '' }}</p>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import { filterTime } from '@/common/js/common.js'
export default {
  props: {
    val: {}
  },
    data(){
        return{
            activeName: 'index0',
            newHospital:[],
            moduleId:''
        }
    },
    created() {
        this.newHospital = this.val.modules;
        this.moduleId = this.val.moduleId;
        // for(let i of this.newHospital){
        //     for(let t of i.articles){
        //         let arr=[]
        //         arr = filterTime(t.releaseTime, 'time').split(' ')
        //         t.releaseTime = arr[0]
        //     }
        // }
    },
    methods:{
        handleClick(){

        },
        rowClick(row){
            let routerPath = this.$router.resolve({
              name: 'ARTICLEDETAIL',
              query: {
                languageId: this.$route.query.languageId,
                model: this.$route.query.model,
                moduleId:this.moduleId,
                modelId: this.$route.query.id,
                level: this.$route.query.level,
                type: this.$route.query.type,
                id: row.id
              }
            });
            window.open(routerPath.href,'_blank')
        },
    },
    watch: {
      val(val) {
        this.newHospital = this.val.modules;
      }
    }
}
</script>
<style lang="less" scoped>
.focusNews{
    .newHospitalMain{
        position: relative;
        /deep/.el-tabs__header{
            padding-left: 0;
        }
        /deep/.el-tabs__header,/deep/.el-tabs__nav-wrap::after{
            background: #f7f7f7;
        }
        /deep/.el-tabs__active-bar{
            background-color: #d11a2e;
            height: 1px;
            bottom:7px;
        }
        /deep/.el-tabs__item.is-active,/deep/.el-tabs__item:hover{
            color: #d11a2e;
        }
        /deep/.el-tabs__content{
            overflow:visible;
        }
        /deep/.el-tabs__nav-wrap.is-scrollable{
            padding: 0 30px;
        }
        /deep/.el-tabs__nav-next, /deep/.el-tabs__nav-prev{
            width: 30px;
            display: inline-block;
        }
        /deep/.el-icon-arrow-left,/deep/.el-icon-arrow-right{
            font-size: 16px;
        }
        .el-tab-pane{
            position: relative;
        }
        ul{
            padding: 0 20px;
            margin: 0 0 10px;
            li{
                width: 100%;
                line-height: 20px;
                font-size: 14px;
                text-align: left;
                span{
                    float: right;
                    color: #666;
                }
                a{
                    color: #333;
                    line-height: 32px;
                    overflow: hidden; /*隐藏*/
                    white-space: nowrap;  /*不换行*/
                    text-overflow: ellipsis;
                    width: 68%;
                    display: inline-block;
                    cursor: pointer;
                    font-weight: bold;
                    i{
                        border-radius: 3px;
                        height: 3px;
                        width: 3px;
                        background: #d11a2e;
                        display: inline-block;
                        margin: 0 10px;
                        position: relative;
                        top:-3px;
                    }
                }
            }
        }
    }
    .newHospitalMainImg{
        top:-53px;
        z-index: 1;
        position: relative;
        overflow: hidden;
        height: 250px;
        cursor: pointer;
        img{
            width: 100%;
            height: 100%;
            display: block;
        }
        p{
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0, 0, 0, .5);
            color: #fff;
            line-height:36px;
            width: 100%;
            text-align:center;
            margin: 0;
            overflow: hidden; /*隐藏*/
            white-space: nowrap;  /*不换行*/
            text-overflow: ellipsis;
            padding: 0 10px;
            box-sizing: border-box;
        }
    }
    .newHospitalMainImg:hover{
        img{
            transform: scale(1.2);
            transition: all 3s;
        }
    }
    @media (min-width: 768px){
        .newHospitalMain{
            /deep/.el-tabs__header{
                padding-left: 20px;
            }

            ul{
                li{
                    line-height: 22px;
                    a{
                        font-weight: normal;
                    }
                }
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/item/patch18.vue